export function createColorStates(spectrum, defaultIndex, disabledSpectrum = spectrum) {
  // TODO: we need a helper for incrementing in *scale steps*, not integer amounts
  return {
    $default: spectrum[defaultIndex],
    hovered: spectrum[defaultIndex + 100],
    pressed: spectrum[defaultIndex + 200],
    focused: spectrum[defaultIndex],
    disabled: disabledSpectrum[defaultIndex - 200]
  };
}
export function createColorProminencesAndStates(spectrum) {
  return {
    $default: createColorStates(spectrum, 500),
    emphasized: createColorStates(spectrum, 600),
    subdued: createColorStates(spectrum, 400)
  };
}
const colorScales = [0, 25, 50, 100, 200, 300, 400, 500, 600, 700, 800, 900];
const colorScalePosition = {
  0: 0,
  50: 1,
  100: 2,
  150: 3,
  200: 4,
  300: 5,
  400: 6,
  500: 7,
  600: 8,
  700: 9,
  800: 10,
  900: 11,
  950: 12
};
export function incrementScaleValueBy(scaleValue, incrementBy) {
  const scaleValueIndex = colorScalePosition[scaleValue];
  const newValueIndex = scaleValueIndex + incrementBy;
  if (newValueIndex < 0 || newValueIndex >= colorScales.length) {
    throw new Error(`Cannot increment color scale "${scaleValue}" by ${incrementBy}`);
  }
  return colorScales[newValueIndex];
}
export function createColorRoot(scale, scaleValue) {
  return {
    root: scale[scaleValue],
    scale,
    scaleValue,
    increment: amount => {
      return scale[incrementScaleValueBy(scaleValue, amount)];
    },
    decrement: amount => {
      return scale[incrementScaleValueBy(scaleValue, -1 * amount)];
    }
  };
}
function hexToRgb(hexColor) {
  const hex = hexColor.replace("#", "");
  if (hex.length === 3) {
    const [r, g, b] = hex.split("");
    return [parseInt(`${r}${r}`, 16), parseInt(`${g}${g}`, 16), parseInt(`${b}${b}`, 16)];
  }
  if (hex.length === 6) {
    var _hex_match;
    const [r, g, b] = (_hex_match = hex.match(/.{1,2}/g)) !== null && _hex_match !== void 0 ? _hex_match : [];
    return [parseInt(r, 16), parseInt(g, 16), parseInt(b, 16)];
  }
  throw new Error(`Invalid hex color: ${hexColor}`);
}
export function hexWithAlpha(hexColor, alpha) {
  const [r, g, b] = hexToRgb(hexColor);
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}